import React, { useCallback, useEffect } from "react";
import { Provider } from "react-redux";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import weui from "weui.js";
import { RequireAuth } from "./components/auth";
import { WeUIDemo } from "./components/weui";
import {
  Bill,
  BindingPush,
  Home,
  Layout,
  Login,
  Message,
  MeterBinding,
  MeterList,
  Order,
  PayChannel,
  PayEntry,
  PayLayout,
  PayResult,
  PaymentDetail,
  PaymentList,
  PowerLimitUserBinding,
  Profile,
  SupportCenter,
  TenPay,
  UserCenter,
  WechatLogin
} from "./pages";
import { refreshLogo, refreshRedux, selectIsMetersLoaded, selectMeters, store } from "./stores";
import { routeUrls, urls } from "./urls";
import "./custom.css";

export const App = props => {
  const navigate = useNavigate();
  const location = useLocation();

  // 检查用户是否已绑表
  const checkMeterBindings = useCallback(() => {
    const isMetersLoaded = selectIsMetersLoaded(store.getState());
    const meters = selectMeters(store.getState());
    const bindingUrl = urls.bindMeter();
    if (isMetersLoaded && meters.length === 0 && !location.pathname.startsWith(bindingUrl)) {
      weui.alert("请您先绑定表计");
      navigate(bindingUrl);
    }
  }, [location, navigate]);
  // 订阅 store 更新, 执行绑表检查
  store.subscribe(() => checkMeterBindings());

  useEffect(() => {
    store.dispatch(refreshLogo());
    refreshRedux();
  }, []);

  useEffect(() => {
    checkMeterBindings();
  }, [checkMeterBindings]);

  const renderAuthLayout = () => {
    return (
      <RequireAuth>
        <Layout>
          <Routes>
            <Route exact path={ routeUrls.home } element={ <Home /> } />

            <Route path={ routeUrls.fee } element={ <PayLayout /> }>
              <Route index element={ <PayEntry /> } />
              <Route path={ routeUrls.feeEntry } element={ <PayEntry /> } />
              <Route path={ routeUrls.feeOrderChannel } element={ <PayChannel /> } />
              <Route path={ routeUrls.feeOrder } element={ <Order /> } />
              <Route path={ routeUrls.feePayments } element={ <PaymentList /> } />
              <Route path={ routeUrls.feePayResult } element={ <PayResult /> } />
              <Route path={ routeUrls.feePaymentDetail } element={ <PaymentDetail /> } />
            </Route>

            <Route path={ routeUrls.bill } element={ <Bill /> } />

            <Route path={ routeUrls.me } element={ <UserCenter /> } />
            <Route path={ routeUrls.meSupport } element={ <SupportCenter /> } />
            <Route path={ routeUrls.meProfile } element={ <Profile /> } />
            <Route path={ routeUrls.meMessage } element={ <Message /> } />
            <Route path={ routeUrls.meMeters } element={ <MeterList /> } />
            <Route path={ routeUrls.meBindMeter } element={ <MeterBinding /> } />
            <Route path={ routeUrls.meBindEBMS } element={ <BindingPush /> } />

            <Route path={ routeUrls.eas.powerLimitBinding } element={ <PowerLimitUserBinding /> } />

            <Route path="/demo" element={ <WeUIDemo /> } />
          </Routes>
        </Layout>
      </RequireAuth>
    );
  };

  return (
    <Provider store={ store }>
      <Routes>
        { /* 此处放置无需登陆的路由 */ }
        <Route exact path={ routeUrls.login } element={ <Login /> } />
        <Route exact path={ routeUrls.loginWechat } element={ <WechatLogin /> } />
        <Route path={ routeUrls.feeTenPay } element={ <TenPay /> } />
        { /* 需要登陆的路由请到 renderAuthLayout 方法中添加 */ }
        <Route path={ routeUrls.requireAuthWild } element={ renderAuthLayout() } />
      </Routes>
    </Provider>
  );
};

App.displayName = App.name;

export default App;
